// ============================================================
// Error pages — Alpine component (hindari inline x-data yang bocor)
// ============================================================

import Alpine from 'alpinejs';

Alpine.data('errorScreen', (config = {}) => ({
  tips: config.tips ?? [],
  tipIndex: 0,
  countdown: config.countdown ?? 8,
  autoRedirect: !!config.autoRedirect,
  redirectUrl: config.redirectUrl ?? '/',

  get currentTip() {
    return this.tips[this.tipIndex] ?? '';
  },

  init() {
    if (this.autoRedirect) {
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
          window.location.href = this.redirectUrl;
        }
      }, 1000);
    }
    setInterval(() => this.nextTip(), 5000);
  },

  nextTip() {
    if (this.tips.length) {
      this.tipIndex = (this.tipIndex + 1) % this.tips.length;
    }
  },

  goBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = this.redirectUrl;
    }
  },
}));
